import { OrganizationKeyName } from "../../../model/Organization";
import { RootState } from "../../../store";

import * as authSelectors from "../../auth/authSelectors";
import { TimeslotTemplateListItem } from "../model/TimeslotTemplatesSuccessResponse";
import { ProductListItem } from "../../products/models/product";

const emptyProductList: ProductListItem[] = [];
Object.freeze(emptyProductList);

const emptyTemplateList: TimeslotTemplateListItem[] = [];
Object.freeze(emptyTemplateList);

export const timeslotTemplates = (
  state: RootState,
  org?: OrganizationKeyName
) => {
  if (!org) {
    org = authSelectors.selectedOrganizationKeyName(state);
  }

  return state.shop.org[org]?.timeslotTemplates || emptyTemplateList;
};

export const product = (
  state: RootState,
  id: string,
  org?: OrganizationKeyName
) => {
  if (!org) {
    org = authSelectors.selectedOrganizationKeyName(state);
  }

  return state.shop.org[org]?.product[id];
};

export const isLoadingProduct = (
  state: RootState,
  id: string,
  org?: OrganizationKeyName
) => {
  if (!org) {
    org = authSelectors.selectedOrganizationKeyName(state);
  }

  return !!state.shop.org[org]?.productIsLoading[id];
};

export const upsertProductErrors = (
  state: RootState,
  id?: string,
  org?: OrganizationKeyName
) => {
  if (!org) {
    org = authSelectors.selectedOrganizationKeyName(state);
  }

  return state.shop.org[org]?.upsertProductErrors[id || "__new"];
};
